export default {
  pageTitle: 'Integrations',
  pageSubtitle:
    'Connect Laplace to the tools your team already uses and get answers built on your entire stack.',
  searchPlaceholder: 'Search integrations...',

  categoryAll: 'All',
  categoryTasks: 'Tasks & Projects',
  categoryDocs: 'Documents',
  categoryDev: 'Development',
  categoryMail: 'Email',
  categoryCalendar: 'Calendars',
  categoryOther: 'Other',

  integrationsCount_one: '{{count}} integration available',
  integrationsCount_other: '{{count}} integrations available',

  noResultsTitle: 'No integrations found',
  noResultsBody: 'Try a different search or pick another category.',

  connectedTitle: 'Connected',
  connectedBadge: 'Available now',
  connectedItemBadge: 'Connected',
  jiraName: 'Jira',
  jiraDesc: 'Tasks, statuses and decision history across tickets.',
  confluenceName: 'Confluence',
  confluenceDesc: 'Documentation, specs and the team wiki.',
  githubName: 'GitHub',
  githubDesc: 'Code, pull requests and change discussions.',
  gmailName: 'Gmail',
  gmailDesc: 'Work correspondence and agreements in email.',
  yandexMailName: 'Yandex Mail',
  yandexMailDesc: 'Yandex 360 mail with data stored in Russia.',
  googleCalendarName: 'Google Calendar',
  googleCalendarDesc: 'Meetings, deadlines and schedules.',
  yandexCalendarName: 'Yandex Calendar',
  yandexCalendarDesc: 'Yandex 360 calendar for teams.',

  soonTitle: 'Coming soon',
  soonBadge: 'In development',
  soonItemBadge: 'Soon',
  kaitenName: 'Kaiten',
  kaitenDesc: 'Kanban boards and team workflows.',
  weeekName: 'Weeek',
  weeekDesc: 'Tasks, projects and a knowledge base.',
  yonoteName: 'Yonote',
  yonoteDesc: 'Knowledge base, notes and internal team procedures.',
  outlookCalendarName: 'Outlook Calendar',
  outlookCalendarDesc: 'Meetings and schedules from Microsoft Outlook.',
  konturName: 'Kontur',
  konturDesc: 'Document workflow and e-signing.',
  telegramName: 'Telegram',
  telegramDesc: 'Work channels, chats and fast team discussions.',
  otherName: 'And more',
  otherDesc: 'New sources are added on request.',

  ctaTitle: 'Need an integration that isn’t listed?',
  ctaBody:
    'Tell us which services your team works with — we’ll prioritize it on the roadmap.',
  ctaButton: 'Request an integration',
}
